export const certificateStatusOptions = [
  { key: "awaiting_leader", label: "Aguardando líder" },
  { key: "pending", label: "Aguardando aprovação final" },
  { key: "approved", label: "Aprovado" },
  { key: "rejected", label: "Reprovado" },
];

export const certificateStatusVariants = {
  awaiting_leader: "warning",
  pending: "warning",
  approved: "success",
  rejected: "danger",
};

export const certificateStatusLabel = (status) =>
  (certificateStatusOptions.find((option) => option.key === status) || {}).label || "-";